import {useState, useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useTanqueData} from "../hooks/TanqueData";
import {TanqueService} from "saneamiento/service";
import {PageLayout} from "base/layout";
import {TanqueSubPageMenu} from "../menu";
import {useAppConfig} from "base/provider";
import {EntityPrintPDFAction} from "base/entity";

const ViewTanquePage = () => {
    const {setSubpagePath, setModuleActions} = useAppConfig();

    const {idTanque} = useParams();
    const [tanque, setTanque] = useState(null);
    const location = useLocation();
    const {getEntityData} = useTanqueData();

    useEffect(() => {
        TanqueService.get(idTanque).then(data => {
            setTanque(data);
            setSubpagePath([
                {name: "Listado de Tanques", path: "tanques"},
                {
                    name: data.nome || data.codigo || "-",
                    path: `${data.id}/summary`,
                },
            ]);
            setModuleActions([
                <EntityPrintPDFAction entityData={getEntityData(data)} />,
            ]);
        });
        return () => {
            setTanque(null);
            setSubpagePath([]);
            setModuleActions([]);
        };
    }, [idTanque, location.state?.lastRefreshDate]);

    return (
        tanque && (
            <PageLayout
                menu={<TanqueSubPageMenu tanque={tanque} />}
                context={[tanque]}
                subPage={true}
            />
        )
    );
};

export default ViewTanquePage;
